import linegraph from '../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import { domainName } from "../../../../utility/index"
import moment from 'moment';

export default {
    props: ["bindBattery"],
    data() {
        return {
            orgId: '',
            batteryNumber: '',
            number: '',
            formInline: {
                batteryNumber: '',
                carId: '',
                warningType: '',
                terminalId: ''
            },
            changeValue: [],
            amountOption: {},
            amountLoading: false,
            height: '500',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false,
                mutiSelect: true, 
                serialNumber: true,
            },
            columnsAll: [
                {
                    prop: "batteryNumber",
                    label: this.$t('BatteryAnalysis.batteryNumber'),
                    align: "center",
                },
                {
                    prop: "carId",
                    label: this.$t('BatteryAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('BatteryAnalysis.terminalId'),
                    align: "center",
                    width: '140'
                },
                {
                    prop: "orgName",
                    label: this.$t('BatteryAnalysis.orgName'),
                    align: "center",

                },
                {
                    prop: "chargeTime",
                    label: this.$t('BatteryAnalysis.chargeTime'),
                    align: "center",

                },
                {
                    prop: "chargeTimeH",
                    label: this.$t('BatteryAnalysis.chargeTimeH'),
                    align: "center",

                },
                {
                    prop: "dischargeTime",
                    label: this.$t('BatteryAnalysis.dischargeTime'),
                    align: "center",

                },
                {
                    prop: "dischargeTimeH",
                    label: this.$t('BatteryAnalysis.dischargeTimeH'),
                    align: "center",
                },
                {
                    prop: "warningCount",
                    label: this.$t('BatteryAnalysis.warningCount'),
                    align: "center",

                },
                {
                    prop: "warningCountH",
                    label: this.$t('BatteryAnalysis.warningCountH'),
                    align: "center",

                },
            ],
            columnsOne: [
                {
                    prop: "happenTime",
                    label: this.$t('BatteryAnalysis.happenTime'),
                    align: "center",
                    width: '180'
                },
                {
                    prop: "endTime",
                    label: this.$t('BatteryAnalysis.endTime'),
                    align: "center",
                    width: '180'
                },
                {
                    prop: "terminalId",
                    label: this.$t('BatteryAnalysis.terminalId'),
                    align: "center",
                    width: '140'
                },
                {
                    prop: "happenElectricity",
                    label: this.$t('BatteryAnalysis.happenElectricity'),
                    align: "center",

                },
                {
                    prop: "endElectricity",
                    label: this.$t('BatteryAnalysis.endElectricity'),
                    align: "center",

                },
                {
                    prop: "eventInterval",
                    label: this.$t('BatteryAnalysis.eventInterval'),
                    align: "center",

                },
                {
                    prop: "judgeRate",
                    label: this.$t('BatteryAnalysis.judgeRate'),
                    align: "center",

                },
                {
                    prop: "rate",
                    label: this.$t('BatteryAnalysis.rate'),
                    align: "center",
                },
                {
                    prop: "isWarningStr",
                    label: this.$t('BatteryAnalysis.raisWarningStre'),
                    align: "center",

                },
                {
                    prop: "chargeTypeStr",
                    label: this.$t('BatteryAnalysis.chargeTypeStr'),
                    align: "center",

                },
            ],
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            isShow: true,
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    created() {
        this.getDate()
    },
    methods: {
        initQuery(type) {
            this.type = type
            this.pageSize = 10
            this.currentPage = 1
            if (type == 'one') {
                this.isShow = false
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.isShow = true
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
        getDate() {
            const endTime = moment().subtract(1, "day").format("YYYY-MM-DD");
            const startTime = moment().subtract(1, "month").format("YYYY-MM-DD");
            this.changeValue = [startTime, endTime];
        },
        changeTime() {
            this.getcarCompare()
            if (this.type == 'one') {
                this.isShow = false
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.isShow = true
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
        getcarCompare() {
            this.amountLoading = true
            let obj = {
                Data: [],
                ChargingTime: [],
                DischargeTime: [],
                ChargingCount: [],
                DischargeCount: [],
            }
            let param = {
                orgId: Number(this.orgId),
                batteryNumber: this.batteryNumber,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            }
            this.$store.dispatch("BatteryAnalysis/GET_QUERYBATTERYCOUNTDRAWING", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.map((item, index) => {
                            obj.Data.push(moment(item.updateTime).format("MM-DD"))
                            obj.ChargingCount.push(item.chargeCount == null ? 0 : item.chargeCount)
                            obj.DischargeCount.push(item.dischargeCount == null ? 0 : item.dischargeCount)
                            obj.ChargingTime.push(item.chargeTime == null ? 0 : item.chargeTime)
                            obj.DischargeTime.push(item.dischargeTime == null ? 0 : item.dischargeTime)
                        })
                        this.carCompare(obj)
                    }
                }
                this.amountLoading = false
            }).catch(err => {
                this.amountLoading = false
            })
        },
        carCompare(amountData) {
            let option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    left: 'center',
                    data: [this.$t('BatteryAnalysis.chargeTime'), this.$t('BatteryAnalysis.dischargeTime'), this.$t('BatteryAnalysis.chargeCount'), this.$t('BatteryAnalysis.dischargeCount')],
                    top: '10',
                    itemWidth: 15, 
                    itemHeight: 15, 
                    textStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',

                        }
                    },
                    splitLine: { show: false },
                    data: amountData.Data
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '5%',
                    containLabel: true,
                },
                yAxis: [{
                    type: 'value',
                    name: this.$t('BatteryAnalysis.count'),
                    nameTextStyle: {
                        color: "white",
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: '#fff'
                    }
                }, {
                    type: 'value',
                    name: this.$t('BatteryAnalysis.duration'),
                    nameTextStyle: {
                        color: "white",
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#fff'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                }],
                series: [
                    {
                        name: this.$t('BatteryAnalysis.chargeCount'),
                        type: 'line',
                        smooth: true,
                        data: amountData.ChargingCount,
                        color: '#f33a3a',
                    },
                    {
                        name: this.$t('BatteryAnalysis.dischargeCount'),
                        type: 'line',
                        smooth: true,
                        data: amountData.DischargeCount,
                        color: '#fec055'
                    },
                    {
                        name: this.$t('BatteryAnalysis.chargeTime'),
                        yAxisIndex: 1,
                        data: amountData.ChargingTime,
                        type: 'bar',
                        barCategoryGap: '40%',
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#16e1ff' },                   
                                        { offset: 1, color: '#1ee2ff' },                   
                                    ]
                                )
                            },
                        }
                    },
                    {
                        name: this.$t('BatteryAnalysis.dischargeTime'),
                        yAxisIndex: 1,
                        data: amountData.DischargeTime,
                        type: 'bar',
                        barCategoryGap: '40%',
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#007cfc' },                   
                                        { offset: 1, color: '#409eff' },                   
                                    ]
                                )
                            },
                        }
                    },
                ]
            }
            this.amountOption = option
        },

        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                batteryNumber: this.formInline.batteryNumber,
                terminalId: this.formInline.terminalId,
                carId: this.formInline.carId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            };
            this.$store.dispatch('BatteryAnalysis/GET_QUERYBATTERYORGANIZATIONPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getMonthOrderList()
        },
        onClear() {
            this.formInline = {
                batteryNumber: '',
                carId: '',
                terminalId: ''
            },
            this.getMonthOrderList()
        },
        getOneMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                batteryNumber: this.batteryNumber,
                warningType: this.formInline.warningType,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            };
            this.$store.dispatch('BatteryAnalysis/GET_QUERYBATTERYSINGLEPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/battery/uploadBatteryOrganizationPage?orgId=${this.orgId}&batteryNumber=${this.formInline.batteryNumber}&terminalId=${this.formInline.terminalId}&carId=${this.formInline.carId}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/battery/uploadBatteryOrganizationPage?orgId=${this.orgId}&batteryNumber=${this.formInline.batteryNumber}&terminalId=${this.formInline.terminalId}&carId=${this.formInline.carId}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                }
            }
        },
        down() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/battery/uploadBatterySinglePage?orgId=${this.orgId}&batteryNumber=${this.bindBattery}&warningType=${this.formInline.warningType}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/battery/uploadBatterySinglePage?orgId=${this.orgId}&batteryNumber=${this.bindBattery}&warningType=${this.formInline.warningType}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            if (this.type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
    }
}
